'use client';

import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

const ScriptRunner: React.FC = () => {
  const pathname = usePathname();

  const searchParams = useSearchParams();

  const scriptLoaded = useRef(false);

  const sku = pathname?.split('/')[2];

  const utmMedium = searchParams.get('utm_medium');

  // List of SKUs you want to allow
  const validSkus = [
    '5XJ',
    'ABP',
    'ADR',
    'ALC',
    'BEL',
    'BHB Testing',
    'BMD',
    'BVP',
    'BVPX',
    'CFP',
    'CUC',
    'discontinued',
    'eBooks',
    'Elements Sample Items',
    'EVPX',
    'FACT',
    'GEN',
    'GLUC',
    'HHV',
    'ILF',
    'JNT',
    'MAX',
    'MHM',
    'MMS',
    'MSM',
    'NEN',
    'SLP',
    'STEM',
    'STEMX',
    'TFX',
    'TJR',
    'TJRG',
    'TRIAL-CHARGE',
    'VIFO',
  ];

  useEffect(() => {
    if (scriptLoaded.current) {
      return;
    }

    if (
      sku &&
      validSkus.includes(sku) &&
      pathname?.startsWith('/landers/') &&
      utmMedium === 'paid'
    ) {
      scriptLoaded.current = true;

      console.log('Adding Script');

      const script1 = document.createElement('script');

      script1.async = true;

      script1.src = 'https://dbmweb.com/Visits/dbx.js?pid=dbm&aid=081b0267';

      document.head.appendChild(script1);

      const script2 = document.createElement('script');

      script2.innerHTML = `
        try {
          const dbxPageInfo = {
            productId: "",
            pageTitle: "GreenValley",
            campaignId: ""
          };
          const dbxPageInfoString = JSON.stringify(dbxPageInfo); 
          if (dbxPageInfoString !== "{}") { 
            window.dbxDataLayer = window.dbxDataLayer || []; 
            function dbxConfig(){ 
              dbxDataLayer.push(arguments); 
            } 
            dbxConfig('externalId', dbxPageInfoString); 
          } 
        } catch (exception) { }`;

      document.head.appendChild(script2);
    }
  }, [pathname, searchParams]);

  return null;
};

export default ScriptRunner;
